<span class="multiple-link" *ngIf="params.value == 'Multiple'"
    (click)="onLinkClicked()">
    {{ "chargeback.multipleLabel" | translate }}
</span>
<span *ngIf="params.value != 'Multiple'">
    {{params.value}}
</span>

<ng-container *ngIf="showModal">
    <multiple-claim-number-list [visibleCustModal]="showModal" [searchObj]="multipleClaimNumberRequest" 
    (closedCustModal)="closedCustModal($event)">
    </multiple-claim-number-list>
</ng-container>